module.exports = __webpack_public_path__ + "img/img11.76b8fd0d.png";